import UserProfile from './UserProfile'
export default UserProfile



// WEBPACK FOOTER //
// ./src/molecules/UserProfile/index.js